import {
	GetAppointmentAttachments,
	GetAppointmentAttachmentsParams,
	AppointmentAttachment,
} from 'domain/usecases';

import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

export class RemoteGetAppointmentAttachments implements GetAppointmentAttachments {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<AppointmentAttachment[]>,
	) {}

	async get(params: GetAppointmentAttachmentsParams): Promise<AppointmentAttachment[]> {
		const httpResponse = await this.httpClient.request({
			url: this.url.replace(':nuControle', params.nuControle),
			method: 'get',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
